import { Form, Button, Alert } from 'react-bootstrap';
import { useState, useEffect } from 'react';
import axiosInstance from '../general/axiosInstance';
import { setIsLoading } from '../general/actions';
import { connect } from 'react-redux';
import AlertModal from '../general/alertModal';

function FundUsers(props) {
    const { fundId, agreementId, department, setIsLoading } = props;

    const [userId, setUserId] = useState('');
    const [users, setUsers] = useState([]);
    const [fundUsers, setFundUsers] = useState([]);
    const [newUserFund, setNewUserFund] = useState(null);

    const [alertModalShow, setAlertModalShow] = useState(false);
    const [alertModalMsg, setAlertModalMsg] = useState('');
    const [alertModalType, setAlertModalType] = useState('');
    const [alertModalOnConfirm, setAlertModalOnConfirm] = useState(null);
    const [alertModalOnClose, setAlertModalOnClose] = useState(null);

    const asignUser = () => {
        setIsLoading(true);
        axiosInstance.post('users-funds', { user_id: newUserFund.id, fund_id: fundId })
            .then(response => {
                setFundUsers([...fundUsers, { ...response.data, user: newUserFund }]);
                setUserId('');
                setNewUserFund(null);
            })
            .catch(error => {
                setAlertModalShow(true);
                setAlertModalType('danger');
                setAlertModalMsg(
                    error.response.data.message.includes('Duplicate')
                        ? 'El usuario ya está asignado a este fondo'
                        : error.response.data.message
                );
            })
            .finally(() => setIsLoading(false));
    };

    const deleteFundUser = (id) => {
        setIsLoading(true);
        axiosInstance.delete('users-funds/' + id)
            .then(() => getFundUsers())
            .catch(console.log)
            .finally(() => setIsLoading(false));
    };

    const getUsersDepartment = () => {
        setIsLoading(true);
        axiosInstance.get('users/departments/' + department)
            .then(res => setUsers(res.data))
            .catch(console.log)
            .finally(() => setIsLoading(false));
    };

    const getFundUsers = () => {
        axiosInstance.get('users-funds/funds/' + fundId)
            .then(res => setFundUsers(res.data))
            .catch(console.log);
    };

    useEffect(() => { props.setHasUsers(fundUsers.length > 0); }, [fundUsers]);

    useEffect(() => {
        if (department) getUsersDepartment(); else setUsers([]);
    }, [department]);

    useEffect(() => {
        if (fundId) { getUsersDepartment(); getFundUsers(); }
    }, []);

    const handleUserChange = (id) => {
        if (!id) return;
        setNewUserFund(users.find(u => u.id === parseInt(id)));
        setUserId(id);
    };

    if (!fundId) {
        return (
            <Alert variant="info" style={{ fontSize: 13 }}>
                <i className="fa fa-info-circle" /> Guarda el fondo para asignar usuarios.
            </Alert>
        );
    }

    return (
        <>
            <div style={{ marginBottom: 10 }}>
                <Form.Label className="report-field-label">Agregar usuario</Form.Label>
                <div style={{ display: 'flex', gap: 8 }}>
                    <Form.Select size="sm" value={userId} onChange={(e) => handleUserChange(e.target.value)} style={{ flex: 1 }}>
                        <option value="">Seleccione un usuario</option>
                        {users.map(u => (
                            <option key={u.id} value={u.id}>{u.name} — {u.email}</option>
                        ))}
                    </Form.Select>
                    <Button size="sm" variant="primary" disabled={!newUserFund} onClick={asignUser}>
                        <i className="fa fa-plus" />
                    </Button>
                </div>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                {fundUsers.length === 0 && (
                    <div style={{ fontSize: 13, color: 'var(--abi-muted)', padding: '8px 0' }}>
                        Sin usuarios asignados
                    </div>
                )}
                {fundUsers.filter(r => r.user).map(rel => (
                    <div key={rel.id} className="config-user-row">
                        <div className="config-user-info">
                            <div className="user-avatar" style={{ width: 28, height: 28, fontSize: 11 }}>
                                {rel.user.name?.[0]?.toUpperCase() || 'U'}
                            </div>
                            <div>
                                <div style={{ fontSize: 13, fontWeight: 600 }}>{rel.user.name}</div>
                                <div style={{ fontSize: 11, color: 'var(--abi-muted)' }}>{rel.user.email}</div>
                            </div>
                        </div>
                        <button className="order-detail-delete-btn" onClick={() => deleteFundUser(rel.id)} title="Quitar">
                            <i className="fa fa-times" />
                        </button>
                    </div>
                ))}
            </div>

            <AlertModal
                show={alertModalShow} setShow={setAlertModalShow}
                msg={alertModalMsg} setMsg={setAlertModalMsg}
                onConfirm={alertModalOnConfirm} setOnConfirm={setAlertModalOnConfirm}
                onClose={alertModalOnClose} setOnClose={setAlertModalOnClose}
                variant={alertModalType}
            />
        </>
    );
}

function mapStateToProps(state) { return { isLoading: state.isLoading }; }
const mapDispatchToProps = { setIsLoading };
export default connect(mapStateToProps, mapDispatchToProps)(FundUsers);
